class Drawer extends HTMLElement {
    constructor() {
        super();
        
        this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
        document.querySelectorAll('.drawer__overlay').forEach(function(overlay) { overlay.addEventListener('click', this.close.bind(this)); }, this);
        this.setIconAccessibility();
        this.onLogin();
    }

    onLogin() {
      const allForms = document.querySelectorAll('#customer_login');
      if (allForms && allForms.length > 0) {
        allForms.forEach(form => {
          form.addEventListener('submit', (evt) => {
            const email = form.querySelector('#CustomerEmail').value;
            const returnTo = form.querySelector('[name="return_to"]');
            returnTo.value = `${window.Shopify.routes.root}account`;
          })
        })
      }
    }

    setIconAccessibility() {
      const links = document.querySelectorAll(`.icon-bubble`);
      links.forEach(function(link) {
        link.setAttribute('role', 'button');
        link.setAttribute('aria-haspopup', 'dialog');
        link.addEventListener('click', (event) => {
          event.preventDefault();
          const drawerToOpen = link.getAttribute("data-open");
          const drawer = document.querySelector(`[data-drawer="${ drawerToOpen }"]`);
          this.open(link, drawer);
        });
        link.addEventListener('keydown', (event) => {
          if (event.code.toUpperCase() === 'SPACE') {
            event.preventDefault();
            this.open(link);
          }
        });
      }, this);
    }

    open(triggeredBy, drawer = this) {
        if (triggeredBy) drawer.setActiveElement(triggeredBy);
        const drawerNote = drawer.querySelector('[id^="Details-"] summary');
        if (drawerNote && !drawerNote.hasAttribute('role')) drawer.setSummaryAccessibility(drawerNote);
        // here the animation doesn't seem to always get triggered. A timeout seem to help
        setTimeout(() => { drawer.classList.add('animate', 'active') });
  
        drawer.addEventListener('transitionend', () => {
        const containerToTrapFocusOn = drawer.classList.contains('is-empty') ? drawer.querySelector('.drawer__inner-empty') : drawer.querySelector('.drawer-wrapper');
        const focusElement = drawer.querySelector('.drawer__inner') || drawer.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      }, { once: true });
  
      document.body.classList.add('overflow-hidden');
      document.body.appendChild(drawer);

    }

    close() {
        document.querySelectorAll("drawer-component").forEach((drawer) => {
          drawer.classList.remove('active');
        });
        removeTrapFocus(this.activeElement);
        document.body.classList.remove('overflow-hidden');
    }

    setSummaryAccessibility(drawerNote) {
        drawerNote.setAttribute('role', 'button');
        drawerNote.setAttribute('aria-expanded', 'false');
    
        if(drawerNote.nextElementSibling.getAttribute('id')) {
          drawerNote.setAttribute('aria-controls', drawerNote.nextElementSibling.id);
        }
    
        drawerNote.addEventListener('click', (event) => {
          event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
        });
    
        drawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
    }

    renderContents(parsedState, openState) {
      this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section => {
        const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
        if(parsedState && parsedState.sections) {
          sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        }
      }));
  
      setTimeout(() => {
        this.querySelector('.drawer__overlay').addEventListener('click', this.close.bind(this));
        if (!document.querySelector('.fs-added-notification'))
          if (openState){
            this.open();
          }
      });
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      selector = ".shopify-section"
      return new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector(selector).innerHTML;
    }

    getSectionsToRender() {
      return [
        {
          id: 'cart-drawer',
          selector: '#CartDrawer'
        },
        {
          id: 'cart-icon-bubble'
        }
      ];
    }

    getSectionDOM(html, selector = '.shopify-section') {
        return new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector(selector);
    }
    
    setActiveElement(element) {
      this.activeElement = element;
    }
}

customElements.define('drawer-component', Drawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
